var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferenceBackgroundImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 400,
    viewBox: "0 0 1440 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 400,
    fill: "#1A1425"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_206_216)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -90,
    width: 1440,
    height: 625,
    fill: "url(#paint0_linear_206_216)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_206_216)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -90,
    width: 1440,
    height: 625,
    fill: "url(#paint1_linear_206_216)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_206_216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 62,
    transform: "matrix(1 0 0 -1 0 483)",
    fill: "url(#paint2_linear_206_216)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_206_216",
    x: -150,
    y: -240,
    width: 1740,
    height: 925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_206_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_206_216",
    x: -150,
    y: -240,
    width: 1740,
    height: 925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_206_216"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_206_216",
    x: -200,
    y: 221,
    width: 1840,
    height: 462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_206_216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_216",
    x1: 833,
    y1: 223,
    x2: 1123,
    y2: 808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_206_216",
    x1: 833,
    y1: 223,
    x2: 881,
    y2: 522.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4F96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_206_216",
    x1: 1440,
    y1: 31,
    x2: 0,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB5097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367217,
    stopColor: "#CF489E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9E55C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceBackgroundImage);
export default __webpack_public_path__ + "static/media/ReferenceBackgroundImage.eee71bd0a13241f138346855508866d9.svg";
export { ForwardRef as ReactComponent };